import React,{useState,useEffect} from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import "./ProjectMaster.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {getProjectMasterList,downloadCategory,deleteProjectMasterRow} from "../function-components/Redux/ProjectMasterSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from "@mui/material/TextField";
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AssignedToDropdownCell from '../function-components/AssignedToDropdownCell';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { DataGridPro, GridActionsCellItem } from '@mui/x-data-grid-pro';

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
// const baseURL = "http://localhost:1101"
const ProjectMasterNew = (props) => {
const dispatch = useDispatch();
const projectMasterList = useSelector((state) => state.projectMaster.projectMasterList);
const [filteredItem, setFilteredItem] = useState("");
const [filteredValues, setFilteredValues] = useState(projectMasterList);
const [page, setPage] = useState(1);
const PER_PAGE = 6;
const startIdx = (page - 1) * PER_PAGE;
const endIdx = startIdx + PER_PAGE;
const currentItems = filteredValues.slice(startIdx,  endIdx);
const count = Math.ceil(filteredValues.length / PER_PAGE);
const [open, setOpen] = useState(false);
const [deleteOpen, setDeleteOpen] = useState(false);
const [openValue,setOpenValue] = useState(false);
const [selectedDesc, setSelectedDesc] = useState("");
const [selectedValue, setSelectedValue] = useState("");
const [selectedRowId, setSelectedRowId] = useState(null);
const [statusRefresh, setStatusRefresh] = useState(false);
const [descRefresh, setDescRefresh] = useState(false);
const [valueRefresh, setValueRefresh] = useState(false);
const [teamMemberRefresh, setTeamMemberRefresh] = useState(false);
const [deleteRow, setDeleteRow] = useState("");
const [showURLModel,setShowURLModel] = useState(false);
const [urlValue,setUrlValue] = useState('');
const [urlId,setUrlId] = useState(0);

useEffect(() => {
  setFilteredValues(projectMasterList)
},[projectMasterList]);

useEffect(() => {
if(filteredItem == undefined || filteredItem == "") {
setFilteredValues(projectMasterList)}
},[filteredItem]);

const handleChange = (e, p) => {
  setPage(p);
};

const theme = createTheme({
  typography: {
  fontFamily: "Graphik-Regular",
  },
  components: {
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: 'none !important',
          },
          '&.Mui-focused:after': {
            borderBottom: 'none !important',
          },
        },
      },
    },
  },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
   };
  
  const handleClose = () => {
    setOpen(false);
  }
  const handleOpen = () =>{
    setOpen(true);
  }

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  }
  const handleDeleteOpen = () =>{
    setDeleteOpen(true);
  }

  const handleValueClose = () => {
    setOpenValue(false);
  }
  const handleValueOpen = () =>{
    setOpenValue(true);
  }


  const handleImageClick = (value, id) => {
    setSelectedDesc(value);
    setSelectedRowId(id);
    handleOpen();
}

const handleDeleteClick = (id) => {
  setSelectedRowId(id);
  handleDeleteOpen();
}

const handleDelete = (e) => {
  e.preventDefault();
  const id = deleteRow.id;
  dispatch(deleteProjectMasterRow(id));
  handleDeleteClose();
 };

  const handleChangeDescription = (e) => {
    setSelectedDesc(e.target.value);
};

const handleValueImageClick = (value, id) => {
  setSelectedValue(value);
  console.log(selectedValue,"selectedValue")
  setSelectedRowId(id);
  handleValueOpen();
}

const handleChangeValue = (e) => {
  setSelectedValue(e.target.value);
}

  function StatusDropdown(props) {
  const { initialValue, onChange } = props;
  const [status, setStatus] = useState(initialValue);


const getColorForStatus = (statusValue) => {
    switch (statusValue) {
        case '2':
          return '#FE7280';
        case '3':
          return '#02A873';
        case '1':
          return 'blue';
        case '4':
          return '#460073';
        default:
          return 'black'; // Default color
       }
      };
      
      
  const handleStatusChange = (e) => {
   const newStatus = e.target.value;
   setStatus(newStatus);
   setStatusRefresh(!statusRefresh)
    if (onChange) {
      onChange(newStatus);
      }
  }

  return (
      <Select value={status} onChange={handleStatusChange} className="status_dropDown" style={{ color: getColorForStatus(status) }}>
      <MenuItem sx={{fontSize:"14px !important"}} value={"1"}>Yet to Start</MenuItem>
      <MenuItem sx={{fontSize:"14px !important"}} value={"2"}>In Progress</MenuItem>
      <MenuItem sx={{fontSize:"14px !important"}} value={"3"}>Completed</MenuItem>
      <MenuItem sx={{fontSize:"14px !important"}} value={"4"}>New</MenuItem>
     </Select>
       );
  }
   

  const useStyles = makeStyles({
    idCell: {
      color: '#7500C0', 
    },
    centeredCell: {
        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
      },
  root: {
        '& .MuiDataGrid-cell': {
          border: 'none !important'
        },
        '& .MuiDataGrid-columnHeader': {
          borderBottom: 'none !important'
        }
      },
  });
  
  const classes = useStyles();

  function handleEndDate(newDate, id) {   
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const formattedDate =  new Date(newDate).toLocaleDateString('en-GB', options);  

    axios.put(`${baseURL}/editProjectMasterList/${id}`,{requested_enddate: formattedDate})
    .then(res => {        
      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setTeamMemberRefresh(!teamMemberRefresh);
    })
    .catch(err => console.log(err))
  }

  function handleStartDate(newDate,id) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const formattedDate =  new Date(newDate).toLocaleDateString('en-GB', options);

    axios.put(`${baseURL}/editProjectMasterList/${id}`,{start_date: formattedDate})
    .then(res => {        
      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setTeamMemberRefresh(!teamMemberRefresh);
    })
    .catch(err => console.log(err))
  }

  function handleRequestedDate(newDate,id) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const formattedDate =  new Date(newDate).toLocaleDateString('en-GB', options);

    axios.put(`${baseURL}/editProjectMasterList/${id}`,{requested_date: formattedDate})
    .then(res => {        
            setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setTeamMemberRefresh(!teamMemberRefresh);
    })
    .catch(err => console.log(err))
  }
  
  const CustomTooltip = withStyles(() => ({
    tooltip: {
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid black',
      borderRadius: '0',
      fontFamily: 'Graphik-Regular',
      fontSize: '12px'
    },
  }))(Tooltip);
  
  const columns = [
    {field: 'action', headerName: 'Action', width: 90, filterable: false, 
    renderCell: (params) => {
    return (
      <div className="image_section">
        <img 
          src="/images/projectMaster/delete_icon.png"
          alt="delete" 
          style={{ width: '45%', marginRight:"10px" }}  onClick={() => {handleDeleteClick(params.row.action, params.id); setDeleteRow(params.row);}}
        />
        <Modal
            // hideBackdrop
            open={deleteOpen}
            onClose={handleDeleteClose}
            aria-labelledby="modal-modal-title2"
            aria-describedby="modal-modal-description2"
            className="delete-modal"
            >
            <Box sx={style}>
            <div>
            <Grid>
            <div className="modal_header_section">
            <h3 className="form_header">Are you sure you want to delete this row?</h3>
            <span className="form_close_btn_model" onClick={handleDeleteClose}>
              <img
              src="/images/projectMaster/Icon awesome-window-close.png"
              alt="icon"
              className="form_close_img"
              />
            </span>
            </div>
            <div className="del-btn-container">
              <Button
              // type="submit"
              className="yes_button"
              variant="contained"
              onClick={handleDelete}
              >
              Yes
              </Button>
              <Button
              // type="submit"
              className="no_button"
              variant="contained"
              onClick={handleDeleteClose}
              >
              No
              </Button>
            </div>
            </Grid>
          </div>
          </Box>
            </Modal>
        </div>
        )
      }
    },
    { field: 'slNo', headerName: 'SL.#', width: 90, filterable: false },
    { 
      field: 'request_id', 
      headerName: 'ID', 
      width: 120,
      cellClassName: classes.idCell, 
      renderCell: (params) => {                        
        return params.value.split("-").join("");
      }
    },
    // {
    //   field: 'request_type',
    //   headerName: 'Type of Request',
    //   width: 150,
    //   editable: false,
    // },
    {
      field: 'category',
      headerName: 'Category',
      width: 110,
      editable: false,
    },
    {
      field: 'name',
      headerName: 'Project Name',
      width: 150,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value || 'NA';
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >            
            {params.row.url === '' ? cellValue : <a href={params.row.url} target="_blank">{cellValue}</a>}
          </div>
        );
      },
    },
    {
        field: 'requested_date',
        headerName: 'Requested date',
        width: 150,
        editable: false,
        // renderCell: (params) => {                    
        //   return <input type="date" className="master-list--requested-date" value={params.value} onChange={(e) => handleRequestedDate(e.target.value,params.id)}/>
        // }
        renderCell: (params) => {
          const {value, id} = params
          const [day, month, year] = value.split('/');
          const dateValue = new Date(year, month - 1, day);
          const isValidDate = !isNaN(dateValue?.getTime());
          return (
            <DatePicker
              selected={isValidDate ? dateValue : null}
              onChange={(newDate)=> handleRequestedDate(newDate, id)}
              className="master-list--requested-date"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD/MM/YYYY"
              // timeFormat="HH:mm"
              //isClearable
            />
          );
        },
    },
    {
        field: 'start_date',
        headerName: 'Start date',
        width: 150,
        editable: false,
        renderCell: (params) => {
          const {value, id} = params
          const [day, month, year] = value.split('/');
          const dateValue = new Date(year, month - 1, day);
          const isValidDate = !isNaN(dateValue?.getTime());
          return (
            <>
             <DatePicker
              selected={isValidDate ? dateValue : null}
              onChange={(newDate) => handleStartDate(newDate, id)}
              className="master-list--requested-date"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD/MM/YYYY"
            />  
            </>
          );
        },
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 110,
        editable: false,
        cellClassName: classes.centeredCell,  
        renderCell: (params,index) => {
            return (
              <div className="image_section">
                <img 
                  src="/images/projectMaster/desc_icon.png"
                  alt="Description" 
                  style={{ width: '55%', marginRight:"10px" }}  onClick={() => handleImageClick(params.row.description, params.id)}
                />
                <Modal
            // hideBackdrop
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title2"
            aria-describedby="modal-modal-description2"
            className="active-modal"
            >
            <Box sx={style}>
            <div>
            <Grid>
            <div className="modal_header_section">
            <h3 className="form_header">Description</h3>
            <span className="form_close_btn_model" onClick={handleClose}>
              <img
              src="/images/projectMaster/Icon awesome-window-close.png"
              alt="icon"
              className="form_close_img"
              />
            </span>
            </div>
            <div className="first_section">
              <div>
              <TextField
              fullWidth
              multiline
              id="desc"
              variant="outlined"
              rows={5}
              required
              sx={{ width: '872px' }}
              value={selectedDesc} 
              onChange={handleChangeDescription}
              />
              </div>
            </div>
            <div className="btn-container">
              <Button
              // type="submit"
              className="save_btn"
              variant="contained"
              onClick={() => {
                axios.put(`${baseURL}/editProjectMasterList/${selectedRowId}`, { description: selectedDesc })
                     .then((res)=>{
                      console.log(res.data)
                      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                      setOpen(false);
                      setDescRefresh(!descRefresh)
                     })
                     .catch((err)=>{
                      console.log(err)
                     })
                }}
              >
              Save
              </Button>
            </div>
            </Grid>
          </div>
          </Box>
            </Modal>
            {props.requestType === "CR" ? "" :
                <img 
                  src="/images/projectMaster/value_icon.png"
                  alt="Value" 
                  style={{ width: '55%' }}  onClick={() => handleValueImageClick(params.row.valueAdded, params.id)}
                />
              }
                 <Modal
            //hideBackdrop
            open={openValue}
            onClose={handleValueClose}
            aria-labelledby="modal-modal-title2"
            aria-describedby="modal-modal-description2"
            className="active-modal"
            >
            <Box sx={style}>
            <div>
            <Grid>
            <div className="modal_header_section">
            <h3 className="form_header">Value</h3>
            <span className="form_close_btn_model" onClick={handleValueClose}>
              <img
              src="/images/projectMaster/Icon awesome-window-close.png"
              alt="icon"
              className="form_close_img"
              />
            </span>
            </div>
            <div className="first_section">
              <div>
              <TextField
              fullWidth
              multiline
              id="desc"
              variant="outlined"
              rows={5}
              required
              sx={{ width: '872px' }}
              value={selectedValue} 
              onChange={handleChangeValue}
              />
              </div>
            </div>
            <div className="btn-container">
              <Button
              // type="submit"
              className="save_btn"
              variant="contained"
              onClick={() => {
                axios.put(`${baseURL}/editProjectMasterList/${selectedRowId}`, { valueAdded: selectedValue })
                     .then((res)=>{
                      console.log(res.data)
                      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                      setShowURLModel(false);
                      setValueRefresh(!valueRefresh)
                     })
                     .catch((err)=>{
                      console.log(err)
                     })
                }}
              >
              Save
              </Button>
            </div>
            </Grid>
          </div>
          </Box>
            </Modal>
              </div>
            );
          },
    },
    {
      field: 'url',
      headerName: 'URL',
      width: 110,
      editable: false,
      cellClassName: classes.centeredCell,  
      renderCell: (params,index) => {
          return <div className="image_section">
            <img src="/images/projectMaster/desc_icon.png" alt="Description" style={{ width: '55%',cursor: 'pointer', marginRight:"10px" }}  
              onClick={() => {setUrlValue(params.row.url);setUrlId(params.row.id);setShowURLModel(true)}} />                                   
            <Modal open={showURLModel} onClose={()=>setShowURLModel(false)} aria-labelledby="modal-modal-title2" 
              aria-describedby="modal-modal-description2" className="active-modal">
              <Box sx={style}>
                <div>
                  <Grid>
                    <div className="modal_header_section">
                      <h3 className="form_header">URL</h3>
                      <span className="form_close_btn_model" onClick={()=>setShowURLModel(false)}>
                        <img src="/images/projectMaster/Icon awesome-window-close.png" alt="icon" className="form_close_img" />
                      </span>
                    </div>
                    <div className="first_section">
                      <div>
                        <TextField fullWidth multiline id="desc" variant="outlined" rows={5} required sx={{ width: '872px',outline: 'none' }}
                          value={urlValue} onChange={(e) => setUrlValue(e.target.value)} />
                      </div>
                    </div>
                    <div className="btn-container">
                      <Button className="save_btn" variant="contained"
                        onClick={() => {
                          axios.put(`${baseURL}/editProjectMasterList/${urlId}`, { url: urlValue })
                          .then((res)=>{                            
                            setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                            setOpenValue(false);
                            setValueRefresh(!valueRefresh)
                          })
                          .catch((err)=>{
                            console.log(err)
                          })
                        }}>
                        Update
                      </Button>
                    </div>
                  </Grid>
                </div>
              </Box>
            </Modal>
          </div>          
        },
  },
    {
      field: 'summary',
      headerName: 'Summary',
      width: 110,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value || 'NA';
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >
            {cellValue}
          </div>
        );
      },
    },
    {
        field: 'stakeholder_name',
        headerName: 'Stakeholder',
        width: 130,
        editable: true,
        renderCell: (params) => {
          const cellValue = params.value || 'NA';
          return (
            <div
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={cellValue}
            >
              {cellValue}
            </div>
          );
        },
    },
    {
        field: 'assigned_to',
        headerName: 'Assigned to',
        width: 220,
        editable: true,  
        renderCell: (params) => (
          params.value ? (
            <CustomTooltip title={params.value} placement="top">
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <AssignedToDropdownCell  
                  initialValue={params.value}
                  onChange={(newValue) => {
                    // const nonEmptyValues = newValue
                    //   .filter(value => value !== undefined && value !== null) // Remove undefined and null values
                    //   .filter(value => value.trim() !== ''); // Remove empty strings
                    // const assigned_to = nonEmptyValues.join(',');
                 
                    const assigned_to = newValue;
                    console.log(newValue, "newValue")
                    console.log(params.row.id, "iddd")
                    axios.put(`${baseURL}/editProjectMasterList/${params.row.id}`, {
                      assigned_to
                    })
                      .then((res) => {
                        console.log(res.data)
                        setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                        setTeamMemberRefresh(!teamMemberRefresh);
                      })
                      .catch((err) => {
                        console.log(err)
                      })
                  }}
                />
              </div>
            </CustomTooltip>
          ) : (
            <AssignedToDropdownCell  
                  initialValue={params.value}
                  onChange={(newValue) => {
                    const nonEmptyValues = newValue
                      .filter(value => value !== undefined && value !== null) // Remove undefined and null values
                      .filter(value => value.trim() !== ''); // Remove empty strings
                    const assigned_to = nonEmptyValues.join(',');
                    console.log(newValue, "newValue")
                    console.log(params.row.id, "iddd")
                    axios.put(`${baseURL}/editProjectMasterList/${params.row.id}`, {
                      assigned_to
                    })
                      .then((res) => {
                        console.log(res.data)
                        setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                        setTeamMemberRefresh(!teamMemberRefresh);
                      })
                      .catch((err) => {
                        console.log(err)
                      })
                  }}
                />
          )
        ),
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 150,
        editable: true,
        renderCell: (params) => {
            return (
              <StatusDropdown 
                initialValue={params.value}
                onChange={(newStatus) => {
                const status = newStatus;
                  axios.put(`${baseURL}/editProjectMasterList/${params.id}`,{
                    status
                    })
                     .then((res)=>{
                      console.log(res.data)
                      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                      setTeamMemberRefresh(!teamMemberRefresh);
                     })
                     .catch((err)=>{
                      console.log(err)
                     })
                }}
              />
            );
          },
    },
    {
        field: 'requested_enddate',
        headerName: 'End date',
        width: 170,
        editable: false,        
        renderCell: (params) => {
          const {value, id} = params;
          const [day, month, year] = value.split('/');
          const dateValue = new Date(year, month - 1, day);
          const isValidDate = !isNaN(dateValue?.getTime());
          return (
            <DatePicker
              selected={isValidDate ? dateValue : null}
              onChange={(newDate) => handleEndDate(newDate, id)}
              className="master-list--requested-date"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD/MM/YYYY"
              //isClearable
            />
          );
        },

    },
    {
        field: 'total_efforts',
        headerName: 'Total Efforts (in hrs)',
        width: 150,
        type: 'number',
        editable: true,
        cellClassName: `${classes.centeredCell} custom-total-efforts-cell`,
        // renderCell: (params) => {
        //     return `${params.value} Hours`;
        //   },
    },
    // {
    //     field: 'goLive',
    //     headerName: 'Go live',
    //     width: 110,
    //     editable: false,
    // },
  ];

  const rows = currentItems.map((data, i) => ({ ...data, slNo: startIdx + i + 1}));
  
  useEffect(() => {
    dispatch(getProjectMasterList(props.requestType));
  }, [statusRefresh,descRefresh,valueRefresh,teamMemberRefresh]);  

  useEffect(() => {
    if (filteredItem === undefined || filteredItem === "") {
      setFilteredValues(projectMasterList);
    } else {
      const filteredData = projectMasterList?.filter(item => (
        (typeof item.id === 'string' && item.id.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.request_id === 'string' && item.request_id.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.name === 'string' && item.name.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.request_type === 'string' && item.request_type.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.category === 'string' && item.category.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.assigned_to === 'string' && item.assigned_to.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.description === 'string' && item.description.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.stakeholder_name === 'string' && item.stakeholder_name.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.requested_date === 'string' && item.requested_date.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.requested_enddate === 'string' && item.requested_enddate.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.start_date === 'string' && item.start_date.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.status === 'string' && item.status.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.summary === 'string' && item.summary.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.total_efforts === 'string' && item.total_efforts.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.valueAdded === 'string' && item.valueAdded.toLowerCase().includes(filteredItem.toLowerCase()))
      ));
      setFilteredValues(filteredData);
    }
  }, [filteredItem, projectMasterList]);


  const [snackbar, setSnackbar] = React.useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);

  const processRowUpdate = React.useCallback(
    async (newRow) => {
      console.log(newRow);
      const id = newRow.id;
      const description = newRow.description;
      const requested_date = newRow.requested_date;
      const requested_enddate = newRow.requested_enddate;
      const start_date = newRow.start_date;
      const stakeholder_name = newRow.stakeholder_name;
      const total_efforts = newRow.total_efforts;

    await axios.put(`${baseURL}/editProjectMasterList/${id}`,{
      description,
      requested_date,
      requested_enddate,
      start_date,
      stakeholder_name,
      total_efforts
    })
     .then((res)=>{
      console.log(res.data)
      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setTeamMemberRefresh(!teamMemberRefresh);
     })
     .catch((err)=>{
      console.log(err)
     })
   },
  );

  const handleDownload = () => {
    dispatch(downloadCategory());
  }
  console.log(filteredValues,"filteredValues")

  const handleFilterModelChange = (newValue) => {
    const newFilteredItem = newValue?.items?.length > 0 ? newValue.items[0].value : "";
    setFilteredItem(newFilteredItem);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ height: 380, width: '95.5%', margin:'auto' }}>
        <DataGrid className='projectControlTable'
          rows={rows}
          columns={columns}
          // initialState={{
          //   pagination: {
          //     paginationModel: {
          //       pageSize: 6,
          //     },
          //   },
          // }}
          // pageSizeOptions={[6]}
          checkboxSelection={false}
          disableRowSelectionOnClick
          disableColumnSelector={true}
          hideFooterPagination                
          processRowUpdate={processRowUpdate}   
          onFilterModelChange={handleFilterModelChange}  
          initialState={{ pinnedColumns: { left: ['action', 'slNo', 'request_id', 'category', 'name']} }} 
        />
        {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
        )}
        <Stack className="pagination_stack">          
          <Pagination count={count} page={page} onChange={handleChange} color="secondary" />    
        </Stack>
      </Box>
    </ThemeProvider>
  )
}

export default ProjectMasterNew;